import React from 'react';
import { IIconProps } from '../interfaces';
import { useTheme } from '@chakra-ui/react';

const AleaEmailSendIcon: React.FC<IIconProps> = ({
  color,
  size = '30',
}) => {
  const theme = useTheme();
  const iconColor = color || theme.colors.alea[500];
  const height = parseInt(String(size), 10);
  const width = (30 / 28) * height;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.1206 17.0783L24.6228 25.3648L28.8278 1L1 12.8734L13.1206 17.0783ZM28.8278 1L13.1206 17.0783M13.1206 17.0783L13.9678 26.4228L17.9711 20.5727"
        stroke={iconColor}
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AleaEmailSendIcon;
